import { Link2 } from 'lucide-react'
import { useNavigate } from './nav'
import { requestChatPromptFill, setPendingChatPrompt } from '../lib/chatPrompt'
import './ConnectIssueTrackerButton.css'

// Same intent the settings page hands off for the "not configured" issue-tracker row, so both entry
// points land the user in the same connect flow (the QA agent surfaces IssueTrackerChatCard).
const CONNECT_PROMPT = 'Set up an issue tracker (GitHub, GitLab, Linear, Jira, or Asana) for filing bugs'

interface ConnectIssueTrackerButtonProps {
  projectId: string
  className?: string
}

// Shown alongside the "Copy bug report" / "Download" actions whenever the project has no issue tracker
// connected. Clicking it takes the user through the connect flow in chat: it seeds the composer with the
// setup prompt (without sending) and navigates to the project overview, where the chat is mounted and
// consumes the pending prompt on mount.
export default function ConnectIssueTrackerButton({ projectId, className }: ConnectIssueTrackerButtonProps) {
  const navigate = useNavigate()

  function handleConnect() {
    // Stash for the standalone case (no chat listening yet) and fire the live fill for a chat already
    // mounted; whichever applies, the other is a harmless no-op.
    setPendingChatPrompt(CONNECT_PROMPT)
    requestChatPromptFill(CONNECT_PROMPT)
    navigate(`/projects/${projectId}/overview`)
  }

  return (
    <button
      type="button"
      className={`connect-issue-tracker-btn${className ? ` ${className}` : ''}`}
      onClick={handleConnect}
      data-testid="connect-issue-tracker-btn"
      data-analytics-event="connect-issue-tracker"
      aria-label="Connect Issue Tracker"
    >
      <Link2 size={14} aria-hidden="true" />
      Connect Issue Tracker
    </button>
  )
}
